<template>
  <v-container class="pt-10">
    <v-card class="world-class-stepper" elevation="3">
      <v-stepper v-model="step" vertical>
        <v-stepper-header>
          <v-stepper-item
            color="red"
            v-for="(item, index) in steps"
            :key="index"
            :title="item.label"
            :value="item.step"
            :complete="step > item.step"
            :class="{ 'active-step': step === item.step }"
          ></v-stepper-item>
          <v-divider></v-divider>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            v-for="(item, index) in steps"
            :key="index"
            :step="item.step"
            v-show="step === item.step"
          >
            <v-form :ref="'form-' + item.step" v-model="valid">
              
              <component 
              :is="item.component" 
              :form-data="item.data"
              @update-form-data="updateFormData(item.step, $event)"
              :ref="'form-' + item.step" 
              />
            </v-form>
            <div class="step-navigation">
              <v-btn v-if="step > 1" color="primary" outlined @click="prevStep">
                Back
              </v-btn>
              <v-btn
                v-if="step < steps.length"
                color="primary"
                @click="validateAndNextStep"
              >
                Next
              </v-btn>
              <v-btn
                v-if="step === steps.length"
                color="success"
                @click="submitData"
              >
                Submit
              </v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-container>


    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" max-width="600px" persistent>
    <v-card class="elevation-26" style="border-radius: 20px; overflow: hidden;">
      <v-card-title class="headline text-center" style="background: linear-gradient(to right, #ff7e5f, #feb47b); color: green; padding: 20px;">
        <v-icon left>mdi-check-circle</v-icon>
        Registration Successful!
      </v-card-title>

      <v-card-text class="text-center" style="font-size: 1.1rem; color: #444;">
        <p>We will be in contact with you soon. Redirecting...</p>
      </v-card-text>

      <v-card-actions class="d-flex justify-center" style="padding-bottom: 20px;">
        <v-btn
          color="primary"
          class="ma-2"
          elevation="10"
          style="border-radius: 50px; font-weight: bold; text-transform: uppercase; padding: 12px 30px;"
          @click="redirectToHome"
        >
          Okay
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar
      v-model="showSnackbar"
      color="red"
      :timeout="snackbarTimeout"
      outlined
    >
    {{ snackbarMessage }}
    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="showSnackbar = false">
        Close
      </v-btn>
    </template>
</v-snackbar>


</template>

<script>
import axios from "axios";
import PersonalInfoForm from "./PersonalInfoForm.vue";
import EducationForm from "./EducationForm.vue";
import EmploymentForm from "./EmploymentForm.vue";
import SelfEmploymentForm from "./SelfEmploymentForm.vue";
import AlumniInvolvementForm from "./AlumniInvolvementForm.vue";
import ContactInfoForm from "./ContactInfoForm.vue";

export default {
  components: {
    PersonalInfoForm,
    EducationForm,
    EmploymentForm,
    SelfEmploymentForm,
    AlumniInvolvementForm,
    ContactInfoForm,
  },
  data() {
    return {
      step: 1,
      valid: true,
      successDialog: false, // To control dialog visibility
      showSnackbar: false, // Controls the visibility of the snackbar
      snackbarMessage: "Please fill all required fields.", // Snackbar message
      snackbarTimeout: 3000, // Duration the snackbar is visible

      steps: [
        { step: 1, label: "Personal Info", component: "PersonalInfoForm", data: {} },
        { step: 2, label: "Education", component: "EducationForm" , data: {}},
        { step: 3, label: "Employment", component: "EmploymentForm", data: {} },
        { step: 4, label: "Alumni Involvement", component: "AlumniInvolvementForm", data: {} },
        { step: 5, label: "Contact Info", component: "ContactInfoForm", data: {} },
      ],

      personalInfo: {}, // This will hold the data for Personal Info form
     educationInfo: {}, // This will hold the data for Education form
    employmentInfo: {}, // This will hold the data for Employment form
    alumniInvolvement: {}, // This will hold the data for Alumni Involvement form
    contactInfo: {}, // This will hold the data for Contact Info form
    };
  },
  methods: {
    initializeEmploymentInfo() {
      return {
        employedOccupation: [
          {
            natureOfEmployment: "",
            employerName: "",
            jobTitle: "",
            placeOfWork: "",
            employerType: "",
          },
        ],
        selfEmployedOccupation: [
          {
            businessType: "",
            businessName: "",
            roleInBusiness: "",
            businessAddress: "",
            businessPhoneNumber: "",
          },
        ],
      };
    },
    initializeAlumniInvolvement() {
      return {
        isInvolvedInKAA: false,
        involvementInKAA: "",
        isInvolvedInKSHS: false,
        involvementInKSHS: "",
        specifyOther: "",
        futurePlanInKSHS: "",
      };
    },
    validateAndNextStep() {
    console.log("Validating form data...");
    console.log(this.step);
    const formRef = this.$refs[`form-${this.step}`];
    console.log(formRef)
    if (formRef[0] && formRef[0].validateForm) {
      console.log("Form data is valid.");
      console.log(formRef[0].validateForm())
      formRef[0].validateForm().then((isValid) => {
        console.log("Validation result:", isValid);
        if (isValid) {
          this.nextStep();
        } else {
          if(this.step === 2) {
            this.snackbarMessage = "Please fill all mandatory fields before proceeding. at least Highschool education information is required.";
          } else {
          this.snackbarMessage = "Please fill all mandatory fields before proceeding.";
          }
          this.showSnackbar = true;
        }
      }).catch((error) => {
        console.error("Error validating form data:", error);
        this.snackbarMessage = "An error occurred during validation.";
        this.showSnackbar = true;
      });
    } else {
      this.snackbarMessage = "No form found. Please try again.";
      this.showSnackbar = true;
    }
  },

  nextStep() {
    if (this.step < this.steps.length) {
      this.step++;
      this.scrollToTop();
    }
  },
  prevStep() {
    if (this.step > 1) {
      this.step--;
      this.scrollToTop();
    }
  },

    submitData() {
      const formRef = this.$refs[`form-${this.step}`];
    if (formRef[0] && formRef[0].validateForm) {
      console.log("Form data is valid.");
      formRef[0].validateForm().then((isValid) => {
        if (isValid) {
       
      // Combine all form data into one alumni object
      const alumniData = {
        personalInfo: this.personalInfo,
        education: this.educationInfo,
        employedOccupation:this.employmentInfo.employed,
        selfEmployedOccupation:this.employmentInfo.selfEmployed,
        alumniInvolvement: this.alumniInvolvement,
        contactInfo: this.contactInfo,
      };


      console.log("Form submitted successfully with data:", alumniData);

      // Log the data to ensure it's correct before sending
      //console.log("Form submitted successfully with data:", alumniData);

          //  axios.post("http://localhost:3000/api/alumni", alumniData)

      // Send the data to the backend using axios
      axios.post(`alumni/${alumniData.personalInfo.id}`, alumniData)
        .then((response) => {
         // console.log("Data submitted successfully:", response.data);
         // alert("Alumni data submitted successfully!");
          
           // Reset all form data
          // this.resetFormData();
          // Show success dialog
          this.successDialog = true;
          // Redirect after 6 seconds
          setTimeout(this.redirectToHome, 3000);
          // Optional: Reset the stepper or form after successful submission
        })
        .catch((error) => {
         // console.error("Error submitting data:", error);
          alert("Failed to submit alumni data. Please try again.");
        });
   
      } else {
          this.snackbarMessage = "Please fill all mandatory fields before proceeding.";
          this.showSnackbar = true;
        }
      }).catch((error) => {
        console.error("Error validating form data:", error);
        this.snackbarMessage = "An error occurred during validation.";
        this.showSnackbar = true;
      });
    } else {
      this.snackbarMessage = "No form found. Please try again.";
      this.showSnackbar = true;
    }
      },

    // Method to reset all form data
    resetFormData() {
      this.personalInfo = {};
      this.educationInfo = {};
      this.employmentInfo = {};
      this.alumniInvolvement = {};
      this.contactInfo = {};


       // Call reset method on each form component
     // Iterate over refs dynamically and reset each form
     // Reset the form validation
   this.$nextTick(() => {
     this.steps.forEach((step) => {
       const formComponentRef = this.$refs[`form-${step.step}`];
       if (formComponentRef && formComponentRef.reset) {
         formComponentRef.reset(); // Call reset method of each form component
       }
     });
   });
    },

    updateFormData(step, data) {
      // const stepData = this.steps.find(item => item.step === step);
      // if (stepData) {
      //   stepData.data = data;
      // }

       // Update the corresponding variable based on the step
    if (step === 1) {
      //console.log("data")
      //console.log(data)
      this.personalInfo = data;
     // console.log("perInfo")
      //console.log(this.personalInfo)
    } else if (step === 2) {
     // console.log("data")
     // console.log(data)
      this.educationInfo = data;
     // console.log("eduInfo")
     // console.log(this.educationInfo)
    } else if (step === 3) {
    //  console.log("Data for eployment")
     // console.log(data)
      this.employmentInfo = data;
     // console.log("EplInf")
    //  console.log(this.employmentInfo)
    } else if (step === 4) {
     // console.log("Data for alumni")
      //console.log(data)
      this.alumniInvolvement = data;
     // console.log("AlInf")
     // console.log(this.alumniInvolvement)
    } else if (step === 5) {
      //console.log("Data for contact")
      //console.log(data)
      this.contactInfo = data;
     // console.log("ContInf")
     // console.log(this.contactInfo)
    }
    },
    scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },

  redirectToHome() {
      // Close the dialog
      this.successDialog = false;

      // Redirect after 6 seconds
        this.$router.push('/alumni');  // This assumes you're using Vue Router for navigation
    },
  }
};
</script>

<style scoped>
/* Container Styling */
.world-class-stepper {
  background: linear-gradient(135deg, #f3f4f6, #ffffff);
  border-radius: 35px;
  /* padding: 20px; */
  /* max-width: 900px; */
  margin: auto;
  /* box-shadow: 0 10px 20px rgb(54, 202, 222); */
  box-shadow: 0 10px 20px rgb(96, 2, 2) !important;

  transition: box-shadow 0.3s ease; /* Smooth hover effect */

}

/* Stepper Styling */
.stepper {
  --v-stepper-header-background: transparent;
  
}

.v-stepper-header {
  background-color: transparent;
}

.v-stepper-item {
  font-family: "Roboto", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #350000;
  text-transform: uppercase;
  padding: 15px 34px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  background: #edf2f7;
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgb(64, 1, 1);

}

.v-stepper-item:hover {
  background: #047c1c;
  transform: scale(1.05);
}

.v-stepper-item.active-step {
  background: linear-gradient(135deg, #B01C04, #350000);
  color: #ffffff;
  box-shadow: 0px 4px 15px #047c1c;
}

.v-divider {
  background-color: #e2e8f0;
}

/* Step Body Styling */
.step-body {
  padding: 10px;
  font-family: "Roboto", sans-serif;
  color: #2d3748;
}

/* Navigation Button Styling */
.step-navigation {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.v-btn {
  font-family: "Roboto", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin:20px;
}

.v-btn:hover {
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

.v-btn[disabled] {
  background-color: #264774 !important;
  color: #34639f !important;
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .world-class-stepper {
    padding: 10px;
  }

  .v-stepper-item {
    font-size: 0.875rem;
    padding: 5px 10px;
  }
}
</style>
